import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  button: {
    padding: '0 0.5rem'
  },

  switchGroup: {
    marginBottom: '1rem'
  },

  switch: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',

    '& .MuiTypography-body1': {
      fontSize: theme.size.sm
    },

    '& .MuiTypography-body1, & .MuiSwitch-root': {
      marginLeft: '0.75rem'
    }
  },
  disabled: {
    cursor: 'not-allowed !important'
  }
}))

export default useStyles
